



















import { Component, Mixins, Prop } from "vue-property-decorator";
import { IReplaceParameters } from "../../../../../../domain/document";
import { InjectedObjectGroundPresentableMixin } from "./mixins";
import { default as InjectedObjectEvidenceDrawer } from "./InjectedObjectEvidenceDrawer.vue";

@Component({
  components: {
    InjectedObjectEvidenceDrawer,
  }
})
export default class InjectedObjectGroundDrawer extends Mixins(InjectedObjectGroundPresentableMixin) {
  @Prop()
  replaceParameters: IReplaceParameters;
}
